import { paginationFragment } from './fragments/pagination';

const fragment = `
  id
  name
  hubSpotValue
  subRegion
  address
  imageUrl
  availability
  status
  buildingType
  type
  description
  longDescription
  hashId
  enableMakeOffer
  externalId
  buildAndPriceStartingPoint
  enableInventoryInsights
  company {
    id
    name
  }
  city {
    id
    name
    state
  }
  lastModifiedLog {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator {
    id
    name
    role
  }
  websiteUrl
  division {
    id
    name
  }
  publishedListingsCount
`;

export const listProjectsQuery = `
  query ListProjects(
    $filter: ProjectFilterInput
    $sort: SortInput
    $page: Int
    $pageSize: Int
  ) {
    result: listProjects(filter: $filter, sort: $sort, page: $page, pageSize: $pageSize) {
      items {
        ${fragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const getProjectQuery = `
  query GetProject($id: Int!) {
    item: getProject(id: $id) {
      ${fragment}
    }
  }
`;

export const createProjectMutation = `
  mutation CreateProject(
    $input: CreateProjectInput!
    $image: Upload
  ) {
    item: createProject(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateProjectMutation = `
  mutation UpdateProject(
    $input: UpdateProjectInput!
    $image: Upload
  ) {
    item: updateProject(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteProjectQuery = `
  mutation DeleteProject(
    $id: Int!
  ) {
    item: deleteProject(id: $id) {
      ${fragment}
    }
  }
`;

export const updateProjectStatusQuery = `
  mutation UpdateProjectStatus(
    $input: UpdateProjectStatusInput!
  ) {
    item: updateProjectStatus(input: $input) {
      ${fragment}
    }
  }
`;

export const listProjectAdminsQuery = `
  query ListProjectAdmins($id: Int!) {
    items: listProjectAdmins(id: $id) {
      id
      name
      email
      phones
      role
    }
  }
`;

export const getProjectInventoryInsightsQuery = `
  query GetProjectInventoryInsights($id: Int!) {
    inventoryInsights: getProjectInventoryInsights(id: $id) {
      publishedListingsCount
      reservationsCount
    }
  }
`;
